<script lang="ts" setup="">
definePageMeta({
  layout: 'nettbutikk-dark',
  name: 'newsletter',
  colorMode: 'light',
})

const { data: cmsData, suspense } = useNewsletterCmsData()

await suspense()
</script>

<template>
  <ContentGrid class="gap-y-2xl mt-m lg:mt-xl mb-xl lg:mb-4xl">
    <div class="grid grid-cols-subgrid col-span-full">
      <Shape variant="octagon" class="fill-blurple-400 h-full justify-self-end 2xl:-mr-[--gutter] -mr-xl hidden lg:block" />

      <header
        v-if="cmsData?.components?.title || cmsData?.components?.leadParagraph?.length"
        class="text-white col-span-4 lg:col-span-6 lg:col-start-2 2xl:col-start-3 flex flex-col gap-s"
      >
        <h1 v-if="cmsData?.components?.title" class="title-xxl" v-text="cmsData?.components?.title" />
        <CrystallizeRichText
          v-for="(block, i) in cmsData?.components?.leadParagraph"
          :key="i"
          :block="block"
          class="title-m"
        />
      </header>
    </div>

    <section class="col-span-full 2xl:col-span-8 2xl:col-start-3 bg-white grid grid-cols-subgrid p-l md:p-2xl rounded-lg">
      <HubspotForm
        v-if="cmsData?.components?.hubspotFormId"
        :id="cmsData?.components?.hubspotFormId"
        class="col-span-full lg:col-span-6 lg:col-start-2 flex flex-col gap-m"
      >
        <template #header>
          <h2
            v-if="cmsData?.components?.formTitle"
            class="title-m"
            v-text="cmsData?.components?.formTitle"
          />
        </template>
      </HubspotForm>
    </section>
  </ContentGrid>
</template>
